import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { stylesColors as colors, stylesTypography as typography } from 'angieslist-styles';
import { Button } from 'angieslist-react-components';
import * as authActions from 'angieslist-app-platform/lib/common/auth/authActions';
import { Track, urlCatalog } from 'angieslist-app-platform';
import { get } from 'lodash';
import './authHeaderSideBar.scss';

const sideBarLinkStyle = {
  fontWeight: typography.fontWeight.lightSemibold,
  color: colors.textBodyDark,
  fontSize: '18px',
};

const hrStyle = {
  borderTop: `1px solid ${colors.iconLight}`,
  margin: '8px 20px',
  width: '85%',
};

const AuthHeaderSideBar = ({
  logout,
  user,
  isAdvertiser,
}) => {
  const userId = get(user, 'userInfo.response.userId');
  return (
    <div className="auth-side-bar-link">
      <Track>
        <a style={sideBarLinkStyle} id="auth-side-bar--home-link" data-track-description="Home" href={urlCatalog.office.home()}>Home</a>
      </Track>
      <hr key="home-divider" style={hrStyle} />
      <If condition={isAdvertiser}>
        <Track>
          <a style={sideBarLinkStyle} id="auth-side-bar--intercom-help-link" data-track-description="Articles & FAQs" href={urlCatalog.global.intercomAssistance()}>Articles & FAQs</a>
        </Track>
      </If>
      <Track>
        <a style={sideBarLinkStyle} id="auth-side-bar--angieslist-link" data-track-description="Visit Member Site" href={urlCatalog.global.angiesListHome()}>Angi.com</a>
      </Track>
      <hr key="account-divider" style={hrStyle} />
      <Track>
        <a style={sideBarLinkStyle} id="auth-side-bar--personal-settings-link" data-track-description="Personal settings" href={urlCatalog.office.account.contactPreferences()}>Personal settings</a>
      </Track>
      <Track>
        <Button style={{ ...sideBarLinkStyle, marginLeft: '20px' }} bsStyle="link" id="auth-side-bar--sign-out-link" onClick={() => logout(userId)} data-track-description="Sign Out">Sign out</Button>
      </Track>
    </div>
  );
};

AuthHeaderSideBar.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isAdvertiser: PropTypes.bool.isRequired,
};

export default compose(
  connect(
    state => ({ user: state.user }),
    { ...authActions },
  ),
  pure,
)(AuthHeaderSideBar);



// WEBPACK FOOTER //
// ./src/app/browser/header/AuthHeaderSideBar.js